const LOCAL_HOSTS = new Set(["localhost", "127.0.0.1", "::1", "[::1]"]);

const ensureTrailingSlash = (value) => (value.endsWith("/") ? value : `${value}/`);

const isLocalHost = (hostname) => LOCAL_HOSTS.has(hostname);

export const getApiBaseUrl = () => {
  const configuredBaseUrl = process.env.REACT_APP_BASEURL || "/";

  if (typeof window === "undefined") {
    return ensureTrailingSlash(configuredBaseUrl);
  }

  try {
    const apiUrl = new URL(configuredBaseUrl, window.location.origin);
    const pageHost = window.location.hostname;

    if (isLocalHost(apiUrl.hostname) && !isLocalHost(pageHost)) {
      apiUrl.protocol = window.location.protocol;
      apiUrl.hostname = pageHost;
    }

    return ensureTrailingSlash(apiUrl.toString());
  } catch (error) {
    return ensureTrailingSlash(configuredBaseUrl);
  }
};

export const API_BASE_URL = getApiBaseUrl();

export const buildApiUrl = (path) => new URL(path.replace(/^\//, ""), API_BASE_URL).toString();
